module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_ciclo_cultivo_2.db241df8.jpg";